<template>
  <Header :resultsFormFactor.sync="formFactor"
          :breadcrumb-items="breadcrumbItems"
          :enable-search="true"
          :uploadTarget="uploadTarget"
          @breadcrumbItemClick="activeFolder = $event"
          @folder-created="refreshFiles = true"
          @space-change="spaceChange"
          @update-upload-target="uploadTarget = null"
          @file-uploaded="refreshFiles = true"
          @tempFiles="tempFiles"
          :title="`Choose a File`"
          :overrideActiveFolder="props.overrideActiveFolder"
  />

  <Files ref="files"
         key-prefix="file-manager"
         :selectedFiles.sync="selectedFiles"
         :resultsFormFactor="formFactor"
         :routePath="computedRoutePath"
         :enable-pagination="true"
         :enable-sort="true"
         :filters="filters"
         :tempFiles="tempTarget"
         :multipleSelection="multipleSelection"
         :refreshFiles="refreshFiles"
         :overrideActiveFolder="props.overrideActiveFolder"
         @fileChosen="fileChosen"
         @folderClick="activeFolder = $event"
         @close-dialog="emit('closeDialog', $event)"
         @fileDelete="fileDelete"
  />

</template>

<script setup>
import {defineEmits, onMounted, ref, watch,computed} from 'vue'
import Files from "./components/Chooser/Files.vue";
import Header from "./components/Chooser/Header.vue";
import {useSlidesStore, useMainStore} from "@/store/index.ts";
import {storeToRefs} from "pinia";
import {useToast} from 'primevue/usetoast';
import {showToast} from '@/utils/showToast'

const props = defineProps({
  multipleSelection: {
    type: Boolean,
    default: false
  },
  filters: {
    type: Array
  },
  overrideActiveFolder: {
    type: Boolean
  }
})

const toast = useToast();


const activeNavItem = ref(null)
const resultsFormFactor = ref('grid')
const selectedFiles = ref([])
const multipleSelection = ref(true)
const filters = ref([])
const tempTarget = ref({})

const slidesStore = useSlidesStore()
const mainStore = useMainStore()
const { valueModelId } = storeToRefs(slidesStore)
const {slideLibraryActive, slideLibraryChooser} = storeToRefs(mainStore)

const emit = defineEmits(['update:selectedFiles', 'update:resultsFormFactor', 'update:resultsSearchQuery', 'fileChosen', 'fileDelete', 'file-uploaded', 'temp-files']);

const spacesFolder = ref('main');
const activeFolder = ref('');
const breadcrumbItems = ref([]);
const routePath = `${import.meta.env.VITE_APP_ENV_SERVER}/lpi-service/file-service/get-folder-files/`;
const formFactor = ref('grid');
const searchQuery = ref('');
const refreshFiles = ref(false);

watch(selectedFiles, (value) => {
  emit('update:selectedFiles', Array.isArray(value) ? value : [value])
})


const spaceChange = (value) => {
  spacesFolder.value = value;
  activeFolder.value = '';
};

const fetchBreadcrumb = async (folderId = '') => {
  const vmId = slideLibraryActive.value ? `?vmId=null` : `?vmId=${valueModelId.value}`;

  const response = await fetch(`${import.meta.env.VITE_APP_ENV_SERVER}/lpi-service/file-service/get-breadcrumb/${spacesFolder.value}/${folderId}${vmId}`);
  const data = await response.json();
  breadcrumbItems.value = data.data;
};

const computedRoutePath = computed(() => {
  const vmId = slideLibraryActive.value ? `?vmId=null` : `?vmId=${valueModelId.value}`;
  return `${routePath}${spacesFolder.value}/${activeFolder.value}${vmId}`;
});

const uploadTarget = ref(null)

const tempFiles = (file) => {
  tempTarget.value = file
}

const fileChosen = async (fileUrl) => {
  if (slideLibraryActive.value && !slideLibraryChooser.value) {
    uploadTarget.value = fileUrl
  }
  else {
    emit('fileChosen', fileUrl)
  }
}



const fileDelete = async (fileUrl) => {
    const params = {
      space: spacesFolder.value,
      vmId: slideLibraryActive.value ? 'null' : valueModelId.value,
      filePath: fileUrl.title
    };

    try {
      const response = await window.fetch(`${import.meta.env.VITE_APP_ENV_SERVER}/lpi-service/file-service/delete-file`, {
        method: 'POST',
        headers: {
          'content-type': 'application/json;charset=UTF-8',
        },
        body: JSON.stringify(params)
      });

      if (response.ok) {
        showToast('success', 'Success', 'File deleted successfully', toast);
        refreshFiles.value = true;
      } else {
        const errorData = await response.json();
        showToast('error', 'Error', errorData.message || 'Failed to delete file', toast);
      }
    } catch (error) {
      showToast('error', 'Error', 'An error occurred while deleting the file', toast);
    }
};

watch(activeFolder, (value) => {
  fetchBreadcrumb(value);
});

watch(selectedFiles, (value) => {
  emit('update:selectedFiles', value);
});

watch(formFactor, (value) => {
  emit('update:resultsFormFactor', value);
});

watch(searchQuery, (value) => {
  emit('update:resultsSearchQuery', value);
});

watch(() => refreshFiles.value, () => {
  console.log(refreshFiles.value)
})

onMounted(() => {
  formFactor.value = props.resultsFormFactor;
  searchQuery.value = ''
  activeFolder.value = ''
  fetchBreadcrumb(activeFolder.value);
});

</script>

<style lang="scss" scoped>

</style>

